<template>
  <div>
    <v-data-table :headers="headers" :items="rawData" class="elevation-1" hide-actions>
      <template #headers>
        <tr>
          <th>Customer name</th>
          <th class="text-xs-center">วันและเวลา<br />ส่งแบบประเมิน</th>
          <th class="text-xs-center">วันและเวลา<br />ตอบแบบประเมิน</th>
          <th class="text-xs-center">คุณรู้สึกชื่นชอบการให้<br />บริการครั้งนี้แค่ไหน</th>
          <th>ข้อเสนอแนะ</th>
        </tr>
      </template>
      <template #items="props">
        <td>{{ props.item.customer_name || '-' }}</td>
        <td>
          <template v-if="props.item.sent_timestamp">
            {{ props.item.sent_timestamp | DateFormat('DD/MM/YYYY hh:mm') }}
          </template>
          <template v-else>-</template>
        </td>
        <td>
          <template v-if="props.item.submit_timestamp">
            {{ props.item.submit_timestamp | DateFormat('DD/MM/YYYY hh:mm') }}
          </template>
          <template v-else>-</template>
        </td>
        <td class="text-xs-center">
          {{ props.item.survey_data.question_1.score || '-' }}
        </td>

        <td>
          {{ props.item.survey_data.suggestion.value || '-' }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import generaliApi from '@/api/generali'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import dayjs from 'dayjs'

export default {
  components: {},
  props: {
    filters: {
      type: Object,
      default: () => {}
    },
    intentName: {
      type: String,
      default: ''
    },
    exportXlsx: {
      type: Date,
      default: null
    }
  },
  data() {
    return {
      pageNumber: 1,
      rowPerPage: 10,
      offset: 0,
      total: 0,
      rawData: [],
      headers: [
        { value: 'intent', sortable: false },
        { value: 'sent_survey_count', sortable: false },
        { value: 'submit_survey_count', sortable: false },
        {
          value: 'sent_survey_count',
          sortable: false
        },
        { sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    currentDateFilter() {
      const startDate = dayjs(this.filters.start_date).format('DD/MM/YYYY')
      const endDate = dayjs(this.filters.end_date).format('DD/MM/YYYY')
      return `${startDate} - ${endDate}`
    }
  },
  watch: {
    filters: {
      handler() {
        this.handlefetchSatisfactionDetail()
      },
      deep: true
    },
    exportXlsx(newVal) {
      if (newVal) {
        this.handleExportXlsx()
      }
    }
  },
  mounted() {},
  methods: {
    async handlefetchSatisfactionDetail() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getExportIntentSatisfactionSurveyDetail()
        vm.$store.dispatch('clear_loading')

        if (response) {
          vm.rawData = response
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    async getExportIntentSatisfactionSurveyDetail() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          sent_survey_date_from: vm.filters.sent_survey_date_from,
          sent_survey_date_to: vm.filters.sent_survey_date_to,
          intent: vm.intentName
        }

        if (vm.filters && vm.filters.customer_name) {
          Object.assign(data, {
            customer_name: vm.filters.customer_name
          })
        }

        if (vm.filters && vm.filters.score_first_question) {
          Object.assign(data, {
            score_first_question: vm.filters.score_first_question
          })
        }

        if (vm.filters && vm.filters.submit_survey_date_from) {
          Object.assign(data, {
            submit_survey_date_from: vm.filters.submit_survey_date_from
          })
        }

        if (vm.filters && vm.filters.submit_survey_date_to) {
          Object.assign(data, {
            submit_survey_date_to: vm.filters.submit_survey_date_to
          })
        }

        const response = await generaliApi.getExportIntentSatisfactionSurveyDetail({
          config: { params: data }
        })

        if (response && response.status === 200) {
          return response.data.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const exportRawData = await vm.getExportIntentSatisfactionSurveyDetail()

        if (!exportRawData) return

        const json = []

        json.push(['รายละเอียดการประเมิน'])
        json.push([`${vm.intentName}`])
        json.push(['Date: ', `${this.currentDateFilter}`])
        json.push([])
        json.push([
          'Customer name',
          'วันและเวลาส่งแบบประเมิน',
          'วันและเวลาตอบแบบประเมิน',
          'คะแนนการประเมิน (คุณรู้สึกชื่นชอบการให้บริการครั้งนี้แค่ไหน)',
          'ข้อเสนอแนะ'
        ])

        exportRawData.map((item) => {
          json.push([
            `${item.customer_name}`,
            `${item.sent_timestamp ? dayjs(item.sent_timestamp).format('DD/MM/YYYY HH:mm') : '-'}`,
            `${
              item.submit_timestamp ? dayjs(item.submit_timestamp).format('DD/MM/YYYY HH:mm') : '-'
            }`,
            `${item.survey_data.question_1.score || '-'}`,
            `${item.survey_data.suggestion.value || '-'}`
          ])
        })

        const heading = [['', '']]
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, json, { origin: 'A1', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `satisfaction-detail.xlsx`)
        vm.$emit('onExportSuccess')
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/generali/SatisfactionSurveyReport/SatisfactionDetail/DataTable.vue